// Gender-Specific Pages
const pages = [
  {
    slug: '/mens-recovery-housing/',
    category: 'Gender-Specific Page', tier: 'Tier 1', gender: 'men',
    name: "Men's Recovery Housing",
    primaryKeyword: "Men's Recovery Housing",
    keywords: ['male recovery housing', "men's recovery home", "men's sober living", "men's recovery housing scholarships"],
    title: "Men's Recovery Housing in the Lehigh Valley, PA | PGSRH",
    description: "PGSRH men's recovery housing offers structured, sober homes for men in Whitehall, PA. Peer support, accountability, and community. Apply today.",
    blurb: "Our hub for men's recovery housing in Whitehall.",
    heroSubtitle: 'Structured, substance-free homes for men in recovery in Whitehall \u2014 built around brotherhood, accountability, and routine.',
    intro: [
      "Men in recovery often do best surrounded by other men who understand the pressures, habits, and expectations that come with rebuilding a life. PGSRH men's recovery housing provides that environment in one Lehigh Valley location: Whitehall.",
      'Our men\u2019s homes emphasize structure, peer accountability, and a shared commitment to sober living. This page is the hub for everything related to men\u2019s recovery housing at PGSRH.',
    ],
    whoFor: [
      'Men leaving treatment, detox, or incarceration who need a stable next step',
      'Men who want a sober, structured home with peer accountability',
      'Families searching for men\u2019s recovery housing for a son, brother, or partner',
      'Referral partners placing male clients in the Lehigh Valley',
    ],
    sections: [
      { h: 'Two men\u2019s homes in the Lehigh Valley', p: [
        'PGSRH operates men\u2019s recovery housing in Whitehall (855 3rd Street). The home provide a substance-free environment, clear house expectations, and a community of men working on the same goals.',
        'Having two locations means more flexibility on availability and the chance to choose the home closest to your work, family, and support network.',
      ] },
      { h: 'What men\u2019s recovery housing offers', p: [
        'Residents share responsibilities, hold one another accountable, and build the daily routine that supports lasting recovery. Living with peers removes the isolation that so often threatens early sobriety.',
        'From this hub you can explore each men\u2019s house page, our men\u2019s sober living options, and information for families searching on a loved one\u2019s behalf.',
      ] },
    ],
    faqs: [
      { q: 'Where is PGSRH men\u2019s recovery housing located?', a: 'We operate a men\u2019s recovery home in Whitehall, PA (855 3rd Street), in the Lehigh Valley.' },
      { q: 'Is men\u2019s recovery housing a treatment program?', a: 'No. It is structured, sober housing with peer support. PGSRH does not provide detox, rehab, therapy, or medical services.' },
      { q: 'How does a man apply?', a: 'Apply online, call 570-579-7695, or have a case manager or treatment team reach out. We will explain availability and next steps.' },
      { q: 'Is there help paying for men\u2019s recovery housing?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what options may apply; approval is not guaranteed.' },
    ],
    fundingHeading: 'Funding options for men\u2019s housing',
    funding: true,
  },
  {
    slug: '/womens-recovery-housing/',
    category: 'Gender-Specific Page', tier: 'Tier 1', gender: 'women',
    name: "Women's Recovery Housing",
    primaryKeyword: "Women's Recovery Housing",
    keywords: ['female recovery housing', "women's recovery home", "women's sober living", "women's recovery housing scholarships"],
    title: "Women's Recovery Housing in Catasauqua, PA | PGSRH",
    description: "PGSRH women's recovery housing offers a safe, structured, sober home for women in Catasauqua, PA. Peer support, accountability, and community. Apply today.",
    blurb: "Our hub for women's recovery housing in Catasauqua.",
    heroSubtitle: 'A safe, structured, substance-free home for women in recovery in Catasauqua \u2014 built around sisterhood, support, and accountability.',
    intro: [
      'Women in recovery often benefit from a home designed specifically for them \u2014 a place where safety, trust, and shared understanding come first. PGSRH women\u2019s recovery housing provides that environment in Catasauqua, PA.',
      'Our women\u2019s home emphasizes structure, peer support, and a sober community. This page is the hub for everything related to women\u2019s recovery housing at PGSRH.',
    ],
    whoFor: [
      'Women leaving treatment, detox, or incarceration who need a stable next step',
      'Women who want a safe, sober, structured home with peer support',
      'Families searching for women\u2019s recovery housing for a daughter, sister, or partner',
      'Referral partners placing female clients in the Lehigh Valley',
    ],
    sections: [
      { h: 'A women\u2019s home in Catasauqua', p: [
        'PGSRH operates women\u2019s recovery housing at 425 Walnut Street in Catasauqua, PA. The home provides a substance-free environment, clear house expectations, and a community of women supporting one another through recovery.',
        'Being in the Lehigh Valley keeps residents close to meetings, employers, family, and the resources they rely on.',
      ] },
      { h: 'What women\u2019s recovery housing offers', p: [
        'Residents share responsibilities, encourage one another, and build the routine and accountability that sustain recovery. A women-specific home creates the kind of safety and trust that make it easier to focus on healing and rebuilding.',
        'From this hub you can explore our Catasauqua women\u2019s house page, women\u2019s sober living options, and guidance for families.',
      ] },
    ],
    faqs: [
      { q: 'Where is PGSRH women\u2019s recovery housing located?', a: 'Our women\u2019s recovery home is at 425 Walnut Street, Catasauqua, PA 18032, in the Lehigh Valley.' },
      { q: 'Is women\u2019s recovery housing a treatment program?', a: 'No. It is structured, sober housing with peer support. PGSRH does not provide detox, rehab, therapy, or medical services.' },
      { q: 'How does a woman apply?', a: 'Apply online, call 610-443-0175, or have a case manager or treatment team reach out. We will explain availability and next steps.' },
      { q: 'Is there help paying for women\u2019s recovery housing?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what options may apply; approval is not guaranteed.' },
    ],
    fundingHeading: 'Funding options for women\u2019s housing',
    funding: true,
  },
  {
    slug: '/mens-sober-living/',
    category: 'Gender-Specific Page', tier: 'Tier 2', gender: 'men',
    name: "Men's Sober Living",
    primaryKeyword: "Men's Sober Living",
    keywords: ['male sober living', "men's sober living homes", 'sober living for men', "men's sober living scholarships"],
    title: "Men's Sober Living in the Lehigh Valley, PA | PGSRH",
    description: "PGSRH men's sober living provides structured, substance-free homes for men in Whitehall, PA. Peer accountability and support. Learn more and apply.",
    blurb: "Sober living for men in Whitehall.",
    heroSubtitle: 'Sober living for men in Whitehall \u2014 a substance-free home with peers who share the same commitment.',
    intro: [
      'Men\u2019s sober living gives men in recovery a substance-free home and a community of peers who understand the road ahead. PGSRH offers men\u2019s sober living in two Lehigh Valley locations, Whitehall.',
      'The environment is structured and accountable \u2014 the everyday framework that helps men protect their sobriety while they work, attend meetings, and rebuild.',
    ],
    whoFor: [
      'Men who want a sober, structured place to live with peers',
      'Men transitioning out of treatment or unstable housing',
      'Men who benefit from routine and peer accountability',
      'Families seeking men\u2019s sober living for a loved one',
    ],
    sections: [
      { h: 'Sober living designed for men', p: [
        'Living with other men in recovery creates a natural accountability and camaraderie. Residents share responsibilities, keep the home substance-free, and support one another through the ordinary pressures of early recovery.',
        'Our men\u2019s homes in Whitehall give you one location option within the same regional service area.',
      ] },
      { h: 'From sober living to independence', p: [
        'Sober living is where men practice real life in a protected setting \u2014 holding a job, showing up to meetings, meeting responsibilities \u2014 so the eventual move to independent living happens on solid ground.',
        'Explore each men\u2019s house page to compare locations, or reach out and we\u2019ll help you find the best fit.',
      ] },
    ],
    faqs: [
      { q: 'Where is men\u2019s sober living located?', a: 'PGSRH men\u2019s sober living is in Whitehall, PA \u2014 both in the Lehigh Valley.' },
      { q: 'Is men\u2019s sober living the same as recovery housing?', a: 'Yes. At PGSRH the terms mean the same thing: a structured, substance-free home with peer support for men in recovery.' },
      { q: 'Does men\u2019s sober living include treatment?', a: 'No. It is housing only. PGSRH does not provide clinical or medical services.' },
      { q: 'Are there scholarships for men\u2019s sober living?', a: 'Scholarship or funding options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/womens-sober-living/',
    category: 'Gender-Specific Page', tier: 'Tier 2', gender: 'women',
    name: "Women's Sober Living",
    primaryKeyword: "Women's Sober Living",
    keywords: ['female sober living', "women's sober living homes", 'sober living for women', "women's sober living scholarships"],
    title: "Women's Sober Living in Catasauqua, PA | PGSRH",
    description: "PGSRH women's sober living provides a safe, structured, substance-free home for women in Catasauqua, PA. Peer support and accountability. Learn more and apply.",
    blurb: "Sober living for women in Catasauqua.",
    heroSubtitle: 'Sober living for women in Catasauqua \u2014 a safe, substance-free home with peers who understand and support one another.',
    intro: [
      'Women\u2019s sober living offers a substance-free home built with the safety, trust, and understanding that many women want during recovery. PGSRH provides women\u2019s sober living in Catasauqua, PA.',
      'The environment is structured and supportive, giving women a dependable place to live while they focus on work, meetings, and rebuilding.',
    ],
    whoFor: [
      'Women who want a safe, sober, structured home',
      'Women transitioning out of treatment or unstable housing',
      'Women who value peer support and accountability',
      'Families seeking women\u2019s sober living for a loved one',
    ],
    sections: [
      { h: 'Sober living designed for women', p: [
        'A women-specific home creates a setting where residents can feel safe and understood. Living with other women in recovery brings natural accountability and encouragement through the ups and downs of early sobriety.',
        'Our Catasauqua home keeps residents close to Lehigh Valley meetings, employers, and family.',
      ] },
      { h: 'From sober living to independence', p: [
        'Sober living lets women practice everyday responsibilities in a protected environment, so the transition to independent living is steadier and more confident.',
        'Visit our Catasauqua women\u2019s house page for location details, or contact us to talk through availability.',
      ] },
    ],
    faqs: [
      { q: 'Where is women\u2019s sober living located?', a: 'PGSRH women\u2019s sober living is at 425 Walnut Street, Catasauqua, PA 18032, in the Lehigh Valley.' },
      { q: 'Is women\u2019s sober living the same as recovery housing?', a: 'Yes. At PGSRH the terms mean the same thing: a structured, substance-free home with peer support for women in recovery.' },
      { q: 'Does women\u2019s sober living include treatment?', a: 'No. It is housing only. PGSRH does not provide clinical or medical services.' },
      { q: 'Are there scholarships for women\u2019s sober living?', a: 'Scholarship or funding options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
];

export default pages;
